<template>
  <div class="delete-reports">
    <p>
    {{ reportCount }} Reports selected for permanent deletion
    </p>
    <p>
    Type 
<span class="delete-reports__delete">delete</span>
in the box to enable delete
    </p>
    <input
      class="delete-reports__input"
      placeholder='Type "delete" here'
      borderless
      v-model="deleteInput"
    />
    <div class="delete-reports__controls">
      <button class="delete-reports__button delete-reports__button_cancel"
              @click.prevent="close()">Cancel
      </button>
      <button class="delete-reports__button delete-reports__button_submit"
              @click.prevent="apply()"
              :disabled="!deleteEnabled"
              >
        Delete
      </button>
    </div>
  </div>
</template>

<script>
import BaseModalMixins from '@/common/BaseModalMixins'

const SELECT_STYLE = {
  'background-color': 'transparent',
  color: '#284aff',
  'text-decoration': 'underline'
}

/**
 * Popup is shown when we want to add new URL
 */
export default {
  name: 'DeleteReportsPopup',
  mixins: [BaseModalMixins],
  components: {
  },
  props: {
    reportCount: {
        type: Number,
        default: 0
    }
  },
  data () {
    return {
      // source_id: 69 - Authority Labs
      // type_id: 72 - Non Priority
      deleteInput: '',
      deleteEnabled: false,
      elementStyle: {},
      titleStyle: {
        overflow: 'visible'
      }
    }
  },
  watch: {
    deleteInput (v) {
        if (v === 'delete') {
            this.deleteEnabled = true
        } else {
            this.deleteEnabled = false
        }
    }
  },
  methods: {
    /**
     * Handling decline creating new URL & hiding component
     */
    close () {
      this.$emit('cancel')
    },
    apply () {
      this.$emit('apply', this.rankReport)
    },
    edit () {
      this.$emit('edit', this.rankReport)
    }
  },
}
</script>

<style lang="scss">
   p {
        // text-align: center;
        margin-left: 20px;
        font-size: 16px;
        font-weight: 500;
        margin: 9px 0 35px;
        color: $rfx-dark-march;
   }
  .delete-reports {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 40px;
    // width: 10vw;

    &__input {

      display: flex;
      flex-direction: column;
      position: relative;
    //   margin-top: 10px;
      // margin-left: 10px;
      // border: 0;
      background-color: #fff;
      border: 1px solid $rfx-light-steel;
      padding: 20px;
      border-radius: 4px;
      outline: none;

        width: 100%;
        box-sizing: border-box;
        padding-right: 60px;
        font-weight: 500;
        @include ellipsis;
    }

    &__title {
      text-align: center;
      font-size: 34px;
      font-weight: 500;
      margin: 9px 0 35px;
      color: $rfx-dark-march;
    }

    &__input {
      display: flex;
      flex-direction: column;
      position: relative;
    //   margin-top: 30px;

      &_invalid[type='text'] {
        border: 1px solid $rfx-red;
        border-radius: 4px;
      }
    }

    &__delete {
      font-weight: 600;
      margin-bottom: 5px;
      color: $rfx-red;
    }
  

    &__controls {
      display: flex;
      justify-content: flex-end;
      margin-top: 30px;
    }
    &__button {
      width: 100px;
      height: 40px;
      border-radius: 4px;
      font-size: 10px;
      font-weight: 900;
      text-transform: uppercase;
      margin-left: 30px;
      border: none;
      outline: none;
      cursor: pointer;

      &_submit {
        background-color: $rfx-red;
        color: #fff;

        &:disabled {
          pointer-events: none;
          background-color: #fff;
          color: $rfx-neutral-grey;
          cursor: default;
        }
      }

      &_delete {
        background-color: $rfx-medium-orange;
        color: #fff
      }

      &_disabled {
        pointer-events: none;
        background-color: #fff;
        color: $rfx-neutral-grey;
        cursor: default;
      }

      &_cancel {
        color: $rfx-dark-march;
        background-color: #fff;
      }
    }
   

  }

 

</style>
